import React from 'react';
import { CssBaseline, Box, Container, Grid } from '@mui/material';
import Banner from '../Layout/Banner';
import HistorySection from './HistorySection';

function History() {
  const url = `${process.env.REACT_APP_STATIC_URL}/uploads/banner/banner_luocsu.png`;
  const title = 'LƯỢC SỬ'
  return (
    <Box>
      <CssBaseline />
      <Banner
        url={url}
        title={title}
      />
      <HistorySection></HistorySection>
    </Box>
  );
}

export default History;